import { onBeforeUnmount, ref } from 'vue';
import { copyTextToClipboard } from '@src/shared/lib/clipboard/copyTextToClipboard';

type UseClipboardCopyOptions = {
	resetDelayMs?: number;
};

export function useClipboardCopy(options: UseClipboardCopyOptions = {}) {
	const isCopied = ref(false);
	const resetDelayMs = options.resetDelayMs ?? 2000;
	let resetTimer: null | ReturnType<typeof setTimeout> = null;

	function clearResetTimer() {
		if (resetTimer) {
			globalThis.clearTimeout(resetTimer);
			resetTimer = null;
		}
	}

	async function copy(text: null | string | undefined): Promise<boolean> {
		if (!text) {
			return false;
		}

		const copied = await copyTextToClipboard(text);
		if (!copied) {
			isCopied.value = false;
			clearResetTimer();
			return false;
		}

		isCopied.value = true;
		clearResetTimer();
		resetTimer = globalThis.setTimeout(() => {
			isCopied.value = false;
			resetTimer = null;
		}, resetDelayMs);
		return true;
	}

	onBeforeUnmount(clearResetTimer);

	return {
		copy,
		isCopied,
	};
}
